import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";

const TONE = { expired: "text-red-800", expires_today: "text-red-800", expiring: "text-amber-800", current: "text-emerald-800" };

// B9: company-wide certificates of insurance, grouped by subcontractor/vendor, soonest expiry first.
export default function CompanyInsurance() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/hse/cois").then((r) => setRows(r.data)).catch((e) => setErr(e?.response?.data?.detail?.message || "Could not load certificates.")); }, []);
  return (
    <AppShell title="Insurance certificates" subtitle="All subcontractors and vendors, soonest expiry first">
      <div className="mx-auto w-full max-w-[900px] px-4 space-y-3" data-testid="hse-insurance">
        {err && <p role="alert" className="text-sm text-red-700" data-testid="hse-insurance-error">{err}</p>}
        {rows && !rows.length && <p className="text-sm" data-testid="hse-insurance-empty">No certificates recorded yet.</p>}
        {(rows || []).map((g) => (
          <section key={g.company_name} className="border border-erf-borderCream rounded bg-white p-3 space-y-1" data-testid={`hse-insurance-${g.company_name}`}>
            <h2 className="font-heading text-lg">{g.company_name} <span className={`text-sm ${TONE[g.status]}`}>· {g.status.replace(/_/g, " ")}</span></h2>
            <ul className="text-sm space-y-1">{g.certificates.map((c) => (
              <li key={c.id} data-testid={`hse-insurance-cert-${c.id}`}>{c.project_name} · {c.carrier} {c.policy_number} · expires {c.expires_on} ({c.days_left} d)</li>))}
            </ul>
          </section>))}
      </div>
    </AppShell>
  );
}
